import { useIsFetching } from '@tanstack/react-query';
import { queryIsBackgroundPoll } from '../query/persisted-schemas';
import { ThinLoadingBar } from './loading';

export function RefreshingIndicator() {
  // A background poll that already has data on screen is refreshing silently:
  // nobody is waiting on it, and on a short interval it would flash this bar on
  // every tick. A cold load still lights it — tagged queries like uploads back
  // a page as well as a poll, and there is nothing to look at yet. See
  // backgroundPollMeta.
  const isFetching = useIsFetching({
    predicate: (query) => !(queryIsBackgroundPoll(query.meta) && query.state.data !== undefined),
  });

  if (!isFetching) {
    return null;
  }

  return <ThinLoadingBar />;
}
